export function getCharterText(getStringRes, key) {
  return getStringRes(key);
}
